import React from 'react';
import { CreateOptimizationButton } from '../../molecules/CreateOptimizationButton';

type MOFilterBarProps = {
  onClick: () => void;
};

export const MOFilterBar: React.FC<MOFilterBarProps> = ({ onClick }) => {
  return <CreateOptimizationButton onClick={onClick} />;
};
